import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { environment } from 'environments/environment';

// Set data-company on body before bootstrap so splash screen shows correct branding
document.body.setAttribute('data-company', environment.company);

bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));
